import { render } from "./AppHeader.vue?vue&type=template&id=4610c260&scoped=true"
const script = {}

import "./AppHeader.vue?vue&type=style&index=0&id=4610c260&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4610c260"]])

export default __exports__